import type { LmsModuleClientDeps, LmsModuleClientType } from '../contracts/client';

export async function load(implementation: 'cet' | 'mocked', deps: LmsModuleClientDeps): Promise<LmsModuleClientType> {
  switch (implementation) {
    case 'cet':
      return (await import('../implementations/cet/src/client')).create(deps);
    case 'mocked':
      return (await import('../implementations/mocked/src/client')).create(deps);
    default:
      throw new Error(`Unknown lms client implementation: ${implementation || '<missing>'}`);
  }
}
